import { render, staticRenderFns } from "./RenewalForm.vue?vue&type=template&id=12cb8ff4"
import script from "./RenewalForm.vue?vue&type=script&lang=js"
export * from "./RenewalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RenewalForm.vue"
export default component.exports